import { Tooltip } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { SHORT_DATETIME_FORMAT } from "../../../../util/varibles/constants";

const formatDuration = (duration: number) => {
    const totalSeconds = Math.max(0, Math.floor(duration / 1000));

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [hours, minutes, seconds]
        .map(item => String(item).padStart(2, "0"))
        .join(":");
};

export default function PauseCount() {
    const [pause] = useTrackingOp(state => state.pause);
    const [pauses = []] = useTrackingOp(state => state.op?.operation.pauses);
    const [currentTime, setCurrentTime] = useState(Date.now());

    const { start_time } = pauses[pause] || {};

    useEffect(() => {
        if (pause === -1 || !start_time)
            return;

        setCurrentTime(Date.now());

        const interval = window.setInterval(() => {
            setCurrentTime(Date.now());
        }, 1000);

        return () => {
            window.clearInterval(interval);
        };
    }, [pause, start_time]);

    const duration = useMemo(() => {
        if (!start_time)
            return "00:00:00";

        return formatDuration(currentTime - start_time);
    }, [currentTime, start_time]);

    if (pause === -1 || !start_time)
        return null;

    return <Tooltip title={`Pause start time: ${datetime(start_time).format(SHORT_DATETIME_FORMAT)}`}>
        <div className="text-[24px] whitespace-nowrap">
            Pause {duration}
        </div>
    </Tooltip>;
}